import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLine } from "@/components/Reveal";
import { ContactSection } from "@/components/ContactSection";

export function FormatPage({ titleTop, titleAccent, description, points, cta, testid, singleLine = false }) {
  return (
    <main className="pt-24 md:pt-32" data-testid={testid}>
      <section className="bg-white">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 pt-14 md:pt-20 pb-20 md:pb-28">
        <h1 className="font-serif font-medium tracking-tighter leading-[0.95] text-5xl" data-testid={`${testid}-headline`}>
          {singleLine ? (
            <MaskedLine delay={0.25}>
              {titleTop}
              <span className="italic text-ember">{titleAccent}</span>
            </MaskedLine>
          ) : (
            <>
              <MaskedLine delay={0.25}>{titleTop}</MaskedLine>
              <MaskedLine delay={0.4}>
                <span className="italic text-ember">{titleAccent}</span>
              </MaskedLine>
            </>
          )}
        </h1>
        <Reveal delay={0.55} className="mt-10 max-w-2xl">
          <p className="text-base md:text-lg text-fog leading-relaxed">{description}</p>
        </Reveal>
        </div>
      </section>

      <section className="border-t border-line">
        <div className="mx-auto max-w-[1400px]">
          {points.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.05}>
              <div className="grid md:grid-cols-12 gap-8 border-b border-line px-6 md:px-12 py-14 md:py-20 group hover:bg-white transition-colors duration-500" data-testid={`${testid}-point-${p.n}`}>
                <div className="md:col-span-2">
                  <span className="font-serif text-6xl md:text-7xl text-ink/15 group-hover:text-leaf transition-colors duration-500">{p.n}</span>
                </div>
                <div className="md:col-span-10 lg:col-span-8">
                  <h2 className="font-serif text-3xl md:text-4xl tracking-tight">{p.title}</h2>
                  <p className="mt-4 text-fog leading-relaxed max-w-2xl">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-b border-line bg-white">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-24 md:py-32">
          <Reveal delay={0.1}>
            <p className="font-serif text-2xl md:text-4xl leading-[1.25] tracking-tight max-w-3xl">{cta}</p>
            <a
              href="mailto:contact@mentheris.com"
              data-testid={`${testid}-contact-link`}
              className="group inline-flex items-center gap-3 bg-ink text-bone px-8 py-4 text-sm tracking-wide hover:bg-ember transition-colors duration-300 mt-10"
            >
              Get in touch
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </Reveal>
        </div>
      </section>

      <ContactSection />
    </main>
  );
}
